import { images } from "../../../Assets/assetsHelper";
import "./StudentProfile.css";
import React from "react";
import { BaseURL } from "../../../Hooks/URL";
import PersonIcon from "@mui/icons-material/Person";
import DeleteForm from "../../../Components/Molecules/DeleteForm/DeleteForm";
import Groups2Icon from "@mui/icons-material/Groups2";
import ClassIcon from "@mui/icons-material/Class";
import CourseCard from "../../../Components/Molecules/Cards/CourseCard/CourseCard";
import { MoonLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import PhoneIcon from "@mui/icons-material/Phone";
import BadgeIcon from "@mui/icons-material/Badge";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import CakeIcon from "@mui/icons-material/Cake";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { getGradeName } from "../../../Assets/grades";

function StudentProfile({
  student,
  setStudent,
  url,
  setGo,
  loading,
  statistics,
  role,
  classesLoading,
  classes,
}) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="mainContainer">
        <div className="loadingContainer">
          <MoonLoader color="#012369" size={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="mainContainer">
      {student && (
        <>
          {/* Action Buttons */}
          {(role === "admin" || role === "school") && (
            <div className="profileActions">
              <button
                className="actionButton primary"
                onClick={() => navigate(`/students/add/${student.id}`)}
              >
                Edit Student
              </button>

              <DeleteForm
                setGo={setGo}
                title={"Are you sure to delete this student?"}
              />
            </div>
          )}

          {/* About Section */}
          <div className="contentSection">
            <div className="aboutStudentHeader">
              <div className="studentLogoSection">
                {student?.photoFilePath ? (
                  <img
                    src={`${BaseURL}/${student?.photoFilePath}`}
                    alt="Student Photo"
                    className="studentLogo"
                  />
                ) : (
                  <div className="studentLogoPlaceholder">
                    <PersonIcon style={{ fontSize: "48px" }} />
                  </div>
                )}
              </div>

              <div className="studentBasicInfo">
                <h1 className="studentName">{student.name}</h1>
              </div>
            </div>

            <h2 className="sectionTitle">Student Details</h2>
            <div className="infoGrid">
              <div className="infoItem">
                <div className="infoLabel">Parent Phone</div>
                <div className="infoValue">{student?.parentPhone || "N/A"}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Gender</div>
                <div
                  className="infoValue"
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {student?.gender == "male" ? (
                    <MaleIcon className="infoIcon male" />
                  ) : (
                    <FemaleIcon className="infoIcon female" />
                  )}
                  {student?.gender == "male" ? "Male" : "Female"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Grade</div>
                <div className="infoValue">
                  {getGradeName(student?.grade) || "N/A"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Birthday</div>
                <div className="infoValue">
                  {student?.birthDay
                    ? new Date(student.birthDay).toLocaleDateString()
                    : "N/A"}
                </div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">Age</div>
                <div className="infoValue">{student?.age || "N/A"}</div>
              </div>
              <div className="infoItem">
                <div className="infoLabel">National ID</div>
                <div className="infoValue">{student?.nationalId || "N/A"}</div>
              </div>
              {role === "admin" && (
                <div className="infoItem">
                  <div className="infoLabel">School</div>
                  <div className="infoValue">
                    <div className="schoolInfo">
                      {student?.school?.logo && (
                        <img
                          src={`${BaseURL}/${student?.school?.logo}`}
                          alt="School Logo"
                          className="schoolLogo"
                        />
                      )}
                      <span>{student?.school?.name || "Skill Code"}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Statistics Grid */}
          <div className="statsGrid">
            <div className="statCard">
              <div className="statIcon primary">
                <ClassIcon />
              </div>
              <div className="statContent">
                <h4>Classes</h4>
                <h2>{classes?.length || 0}</h2>
              </div>
            </div>
            {/* <div className="statCard">
              <div className="statIcon success">
                <Groups2Icon />
              </div>
              <div className="statContent">
                <h4>Enrolled</h4>
                <h2>Active</h2>
              </div>
            </div>
            <div className="statCard">
              <div className="statIcon warning">
                <PersonIcon />
              </div>
              <div className="statContent">
                <h4>Grade Level</h4>
                <h2>Student</h2>
              </div>
            </div> */}
          </div>

          {/* Latest Classes Section */}
          <div className="contentSection">
            <div className="classesHeader">
              <h2 className="sectionTitle">Enrolled Classes</h2>
              <button
                className="actionButton primary"
                onClick={() => navigate("/classes")}
              >
                See All Classes
              </button>
            </div>
            {classesLoading ? (
              <div className="loadingContainer">
                <MoonLoader color="#012369" size={40} />
              </div>
            ) : classes?.length ? (
              <div className="classesGrid">
                {classes?.map((item) => (
                  <CourseCard
                    class_id={item?.id}
                    class_name={item?.name}
                    course={item?.course?.title}
                    teacher={item?.teacher?.name}
                    school={item?.school?.name}
                    terminated={item?.isTerminated}
                  />
                ))}
              </div>
            ) : (
              <div className="emptyState">
                <h3>No Classes Enrolled Yet</h3>
                <p>
                  Classes will appear here once this student is enrolled in
                  classes
                </p>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default StudentProfile;
